import React, { Component } from "react";
import jwt_decode from "jwt-decode";

class Callback extends Component {
  constructor(props) {
    super(props);
    this.state = { user: undefined };
  }

  componentWillMount() {
    let id_token = window.location.hash.substr(1).split("=")[1].split("&")[0];
    let nonce = localStorage.getItem("nonce");
    localStorage.removeItem("nonce");
    let decoded = jwt_decode(id_token);
    if (nonce !== decoded.nonce) {
      return;
    }
    this.setState({ user: decoded });
    localStorage.setItem("id_token", id_token);
    window.location.href = "/on-air";
  }

  render() {
    return (
      <div>
        If you see this you are authenticated as{" "}
        {this.state.user ? this.state.user.name : "Anonymous"}.
      </div>
    );
  }
}

export default Callback;
